export const ROUTES = {
  // Marketing pages
  productCore: '/core/',
  productMaterial: '/material-ui/',
  productAdvanced: '/x/',
  productToolpad: '/toolpad/',
  productTemplates: '/templates/',
  productDesignKits: '/design-kits/',
  careers: '/careers/',
  pricing: '/pricing/',
  about: '/about/',
  blog: '/blog/',
  customers: '/customers/',
  // Material UI doc pages
  materialDocs: '/material-ui/getting-started/',
  materialIcons: '/material-ui/material-icons/',
  materialAllComponents: '/material-ui/all-components/',
  freeTemplates: '/material-ui/getting-started/templates/',
  components: '/material-ui/getting-started/supported-components/',
  customization: '/material-ui/customization/how-to-customize/',
  theming: '/material-ui/customization/theming/',
  documentation: '/material-ui/getting-started/',
  showcase: '/material-ui/discover-more/showcase/',
  coreRoadmap: '/material-ui/discover-more/roadmap/',
  vision: '/material-ui/discover-more/vision/',
  support: '/material-ui/getting-started/support/',
  goldSponsor: '/material-ui/discover-more/backers/#gold-sponsors',
  // Base UI doc pages
  baseDocs: 'https://base-ui.com/',
  baseComponents: 'https://base-ui.com/react/components',
  baseQuickstart: 'https://base-ui.com/react/overview/quick-start',
  // System pages
  systemDocs: '/system/getting-started/',
  // X general pages
  xIntro: '/x/introduction/',
  xRoadmap: 'https://github.com/orgs/mui/projects/35',
  xLicensing: '/x/introduction/licensing/',
  // Data Grid doc pages
  dataGridOverview: '/x/react-data-grid/',
  dataGridDocs: '/x/react-data-grid/quickstart/',
  dataGridFeatures: '/x/react-data-grid/features/',
  dataGridFeaturesComparison: '/x/react-data-grid/features/',
  // Date and Time Pickers doc pages
  datePickersOverview: '/x/react-date-pickers/',
  // Charts doc pages
  chartsOverview: '/x/react-charts/',
  // Tree View doc pages
  treeViewOverview: '/x/react-tree-view/',
  // Scheduler doc pages
  schedulerOverview: '/x/react-scheduler/',
  // Chat doc pages
  chatOverview: '/x/react-chat/',
  // Toolpad pages
  toolpadLandingPage: '/toolpad/',
  toolpadStudioLandingPage: '/toolpad/studio/',
  toolpadStudioDocs: '/toolpad/studio/getting-started/',
  toolpadCoreDocs: '/toolpad/core/introduction/',
  toolpadStudioWhy: '/toolpad/studio/getting-started/why-toolpad/',
  // External pages
  rssFeed: '/feed/blog/rss.xml',
  handbook: 'https://mui-org.notion.site',
  privacyPolicy: 'https://mui.com/legal/privacy/',
  store: 'https://mui.com/store/',
};
